export default __webpack_public_path__ + "static/media/blobL.7ea65972.png";